
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payInstallment/[id]",
      function () {
        return require("private-next-pages/payInstallment/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/payInstallment/[id]"])
      });
    }
  